<div class="login-container"  style="height: auto;overflow: auto;">

    <h2>Login</h2>

    <form (ngSubmit)="onLogin()" [formGroup]="loginForm" class="login-form">
        <!-- Username -->
        <div class="form-group">
            <label for="identifier">User ID</label>
            <input id="identifier" type="text" formControlName="identifier" placeholder="Enter User ID" />
        </div>

        <!-- Password -->
        <div class="form-group password-group">
            <label for="password">Password</label>

            <div class="password-wrapper">
                <input
                        id="password"
                        [type]="showPassword ? 'text' : 'password'"
                        formControlName="password"
                        placeholder="Enter Password"
                />

                <button
                        type="button"
                        class="toggle-password"
                        (click)="togglePassword()"
                        aria-label="Toggle password visibility"
                >
                    <!-- Eye Open -->
                    <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="eye-icon">
                        <path d="M12 5c-7 0-10 7-10 7s3 7 10 7 10-7 10-7-3-7-10-7zm0 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"/>
                    </svg>

                    <!-- Eye Closed -->
                    <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="eye-icon">
                        <path d="M2 2l20 20M10.6 10.6a2 2 0 0 0 2.8 2.8M9.9 5.1A10.9 10.9 0 0 1 12 5c7 0 10 7 10 7a17.6 17.6 0 0 1-4 5.2M6.1 6.1A17.5 17.5 0 0 0 2 12s3 7 10 7c1.4 0 2.7-.3 4-.8"/>
                    </svg>
                </button>
            </div>
        </div>

        <!-- Buttons -->
        <div class="button-group">
            <button *ngIf="!isPlacingOrder"
                    class="LoginBtn"
                    type="submit" [disabled]="loginForm.invalid">Login</button>
            <span *ngIf="isPlacingOrder" class="loader"></span>
            <button class="LoginBtn" type="button" (click)="onRegister()">Register</button>
        </div>
    </form>
</div>